<template lang="html">
  <v-dialog v-model="ShowPopup" :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" text @click="closePopup">
          No
        </v-btn>

        <v-btn color="primary" outlined @click="action(index)">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MiddlePopup',
  props: {
    action: {
      required: true,
      type: Function
    },
    title: {
      default: '',
      type: String
    },
    message: {
      default: '',
      type: String
    },
    width: {
      default: 290,
      type: Number
    }
  },
  data() {
    return {
      ShowPopup: false,
      index: 0
    }
  },
  mounted() {
    this.$root.$on('ShowPopup', (dataMenu) => {
      this.ShowPopup = dataMenu.ShowPopup
      this.index = dataMenu.idItem
    })
    this.$root.$on('ClosePopup', (dataMenu) => {
      this.ShowPopup = dataMenu
    })
  },
  methods: {
    closePopup() {
      this.ShowPopup = false
      this.$root.$emit('ClosePopup', this.show)
    }
  }
}
</script>
